import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import * as snackbarSelectors from '../../../modules/common/redux/selectors/snackbar';

import Stack from '../Stack/Stack';
import Snackbar from './Snackbar';
import SnackbarItem, { ToastType } from './SnackbarItem';

type Props = {
  maxSnack: number;
};

function SnackbarGroup({ maxSnack }: Props) {
  const notifications = useSelector(snackbarSelectors.notifications) as ToastType[];
  const [forceCloseElement, setForceCloseElement] = useState<string | null>(null);
  const [firstToast] = notifications;

  const notificationsToShow = notifications.slice(0, maxSnack).reverse();

  useEffect(() => {
    if (notifications.length > maxSnack) {
      const key = notificationsToShow[notificationsToShow.length - 1]?.key;

      if (key) {
        setForceCloseElement(key);
      }
    }
  }, [notifications.length]);

  return (
    <Snackbar
      open={!!firstToast}
      autoHideDuration={null}
      transitionDuration={0}
      anchorOrigin={{
        vertical: firstToast?.position?.vertical || 'bottom',
        horizontal: firstToast?.position?.horizontal || 'left',
      }}
      sx={{
        mt: 'env(safe-area-inset-top)',
        mb: 'env(safe-area-inset-bottom)',
      }}
    >
      <Stack spacing={2} flexDirection="column">
        {notificationsToShow.map((toast: ToastType) => (
          <SnackbarItem toast={toast} key={toast.key} forceClose={forceCloseElement === toast.key} />
        ))}
      </Stack>
    </Snackbar>
  );
}

export default SnackbarGroup;
